// extracted by mini-css-extract-plugin
export default {"fileName":"DocumentFileName_fileName__p8f8y","icon":"DocumentFileName_icon__dTxgh"};